// generated from 156_535 samples

import { z } from "zod";

export const madeAnyPurchaseTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::MadeAnyPurchase"),
});
